<template>
    <td :class="tdClass">
      <div class="flex items-center space-x-3">
        <template v-if="item.customerPayment">
          <img v-if="isApplePay" src="~/assets/images/integrations/apple_pay_icon.png" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-if="isGooglePay" src="~/assets/images/integrations/google_pay_icon.png" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-if="isKlarna" src="~/assets/images/integrations/klarna_icon.png" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-if="isLink" src="~/assets/images/integrations/link_icon.png" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-if="isCashApp" src="~/assets/images/integrations/cash_app_icon.png" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-if="isAfterpayClearpay" src="~/assets/images/integrations/clearpay_afterpay_icon.jpg" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-if="isAmazonPay" src="~/assets/images/integrations/amazon_pay_icon.png" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-if="isIdeal" src="~/assets/images/integrations/ideal_icon.png" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-if="isKonbini" src="~/assets/images/integrations/konbini_icon.png" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-if="isRevolutPay" src="~/assets/images/integrations/revolut_pay_icon.png" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-if="isWechatPay" src="~/assets/images/integrations/wechat_pay_icon.png" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-if="isZip" src="~/assets/images/integrations/zip_icon.png" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-else-if="isStripe" src="~/assets/images/integrations/stripe_icon.png" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-else-if="isSquare" src="~/assets/images/integrations/square_icon.jpg" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-else-if="isZettle" src="~/assets/images/integrations/zettle_icon.png" class="h-8 w-8 opacity-85 shadow rounded-xl">
          <img v-else-if="isSumUp" src="~/assets/images/integrations/sumup_icon.png" class="h-8 w-8 opacity-85 shadow rounded-xl">
        </template>

        <img
          v-else-if="item.hasImage"
          class="bg-gray-200  rounded-xl h-8 w-8 flex justify-center items-center shadow"
          :src="item.image"
        >

        <div v-else class="bg-gray-200 text-gray-700 rounded-xl h-8 w-8 flex justify-center items-center shadow">
          <o-icon :icon="icon" :size="18" />
        </div>
        <div>
          <template v-if="isPaymentRequest">
            <div class="flex items-center space-x-3">
              <p>
                {{ $t('general.paymentRequest') }}
              </p>
              <p>
                <o-chip v-if="item.isStatusRequested" variant="success" flat size="xs">
                  {{ $t('general.requested') }}
                </o-chip>
                <o-chip v-if="item.isStatusScheduled" variant="warning" flat size="xs">
                  {{ $t('general.scheduled') }}
                </o-chip>
                <o-chip v-if="item.isStatusPaid" variant="success" flat size="xs">
                  {{ $t('general.paid') }}
                </o-chip>
                <o-chip v-if="item.isStatusExpired" variant="danger" flat size="xs">
                  {{ $t('general.expired') }}
                </o-chip>
                <o-chip v-if="item.isStatusCancelled" variant="danger" flat size="xs">
                  {{ $t('general.cancelled') }}
                </o-chip>
              </p>
            </div>

            <p class="text-xs uppercase">
              {{ $date.format($date.local(item.created_at * 1000), $date.presets.full) }}
            </p>
          </template>
          <template v-else>
            <p v-if="item.customerCourse?.course">
              {{ item.customerCourse.course.name }} - {{ item.customerCourse.courseRun?.information }}
            </p>
            <p v-else>
              {{ item.displayLabel }}
            </p>
            <p v-if="item.infoLabel" class="text-xs">
              {{ item.infoLabel }}
            </p>
            <p v-if="item.dateLabel" class="text-xs">
              {{ item.dateLabel }}
            </p>
            <p v-if="item.employee" class="text-xs">
              {{ item.employee.displayName }}
            </p>
          </template>
          <p class="text-xs uppercase">
            <span v-if="item.customerPayment">
              <template v-if="item.customerPayment.cardType">
                {{ item.customerPayment.cardType }} <span v-if="item.customerPayment.cardLast4">({{ item.customerPayment.cardLast4 }})</span> -
              </template>
              <template v-if="item.customerPayment.type === 'terminal'">
                {{ $t('components.order.elements.orderItem.terminalPayment') }}
              </template>
              <template v-else-if="isKlarna">
                Klarna
              </template>
              <template v-else-if="isGooglePay">
                Google Pay
              </template>
              <template v-else-if="isApplePay">
                Apple Pay
              </template>
              <span v-else-if="isLink">
                Stripe Link
              </span>
              <span v-else-if="isCashApp">
                Cash App
              </span>
              <span v-else-if="isAfterpayClearpay">
                Afterpay/Clearpay
              </span>
              <span v-else-if="isAmazonPay">
                Amazon Pay
              </span>
              <span v-else-if="isIdeal">
                iDEAL
              </span>
              <span v-else-if="isKonbini">
                Konbini
              </span>
              <span v-else-if="isPayByBank">
                Pay by Bank
              </span>
              <span v-else-if="isRevolutPay">
                Revolut Pay
              </span>
              <span v-else-if="isWechatPay">
                WeChat Pay
              </span>
              <span v-else-if="isZip">
                Zip
              </span>
              <span v-else-if="isStripeOther">
                {{ isStripeOther }}
              </span>
              <span class="px-1">
                |
              </span>
            </span>
            <span v-if="item.createdDateTimeLabel">{{ item.createdDateTimeLabel }}</span>
          </p>

          <div v-if="item.voucher || item.isReservationStatusCancelled || item.customerCourse?.payment?.isEarly || item.customerCourse?.payment?.schemeName" class="flex items-center space-x-1 mt-1">
            <o-chip v-if="item.customerCourse?.payment?.schemeName" size="sm" variant="primary" flat>
              {{ item.customerCourse.payment.schemeName }}
            </o-chip>

            <o-chip v-if="item.customerCourse?.payment?.isEarly" size="sm" variant="info" flat>
              {{ $t('general.earlyBird') }}
            </o-chip>

            <o-chip v-if="item.voucher" size="sm" variant="success">
              {{ $t('components.order.elements.orderItem.voucher', { code: item.voucher.code }) }}
            </o-chip>

            <o-chip v-if="item.isReservationStatusCancelled" size="sm" variant="danger">
              {{ $t('general.cancelled') }}
            </o-chip>
          </div>
        </div>
      </div>
    </td>
    <td class="w-1/6" :class="[tdClass, { 'hidden' : isClosed }]">
      <div v-if="!isClosed" class="mr-3 flex items-center space-x-1">
        <template v-if="isPaymentRequest">

        </template>
        <template v-else>
          <o-tooltip v-if="editAllow" :text="$t('components.order.elements.orderItem.edit')">
            <o-button size="sm" icon="edit" @click="handleEditItem(item)" />
          </o-tooltip>

          <o-tooltip v-if="refundAllow" :text="$t('components.order.elements.orderItem.refundPayment')">
            <o-button variant="danger" size="sm" flat icon="refund" @click="handleRefundPayment(item)" />
          </o-tooltip>

          <o-tooltip v-if="isStripe && stripePaymentUrl" :text="$t('components.order.elements.orderItem.viewStripePayment')">
            <o-button size="sm" icon="sale" :href="stripePaymentUrl" target="_blank" />
          </o-tooltip>

          <o-tooltip v-if="deleteAllow" :text="$t('components.order.elements.orderItem.removeFromSale')">
            <o-button variant="danger" size="sm" flat icon="delete" @click="handleDeleteItem(item)" />
          </o-tooltip>
        </template>
      </div>
    </td>
    <td :class="tdClass" class="w-1/6">
      <span class="font-medium" :class="{ 'line-through text-gray-600' : item.discountAmount }">
        <template v-if="isPaymentRequest">
          {{ item.amountLabel }}
        </template>
        <template v-else-if="item.isCharge && item.isAmountTypePercentage && item.finalPriceLabel">
          {{ item.finalPriceLabel }} ({{ item.priceLabel }})
        </template>
        <template v-else>
          {{ item.priceLabel }}
        </template>
      </span>

      <span v-if="item.discountAmount" class="ml-3 font-medium">
        {{ discountLabel }}
      </span>
    </td>
</template>

<script setup lang="ts">
import { OrderItemType, OrderItemPaymentType } from '@/_api/models/orderItem'

import {
  OAvatar,
} from '@/components/elements'

const { $currency } = useNuxtApp()

interface Props {
  item: any
  tdClass?: string
  isClosed?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  tdClass: '',
  isClosed: false,
})

const handleEditItem = inject('handleEditItem') as Function
const handleDeleteItem = inject('handleDeleteItem') as Function
const handleRefundPayment = inject('handleRefundPayment') as Function

const isPaymentRequest = computed(() => {
  return !!(props.item.isStatusRequested !== undefined ||
            props.item.isStatusScheduled !== undefined ||
            props.item.isStatusPaid !== undefined ||
            props.item.isStatusExpired !== undefined ||
            props.item.isStatusCancelled !== undefined ||
            props.item.amountLabel)
})

const icon = computed(() => {
  if (isPaymentRequest.value) {
    return 'payment'
  }

  const itemType = props.item.type

  if (itemType === OrderItemType.payment) {
    const paymentType = props.item.paymentType

    switch (paymentType) {
      case OrderItemPaymentType.cash: return 'cash'
      case OrderItemPaymentType.customerCredit: return 'customerCredit'
      case OrderItemPaymentType.giftCard: return 'giftCard'
      case OrderItemPaymentType.loyaltyPoints: return 'loyaltyPoints'
      case OrderItemPaymentType.customerPayment: return 'creditCard'
      default: return 'payment'
    }
  }

  switch (itemType) {
    case OrderItemType.reservation:
    case OrderItemType.reservationCustomer:
    case OrderItemType.reservationService:
    case OrderItemType.service: return 'reservation'
    case OrderItemType.product: return 'product'
    case OrderItemType.charge: return 'charge'
    case OrderItemType.discount: return 'discount'
    case OrderItemType.payment: return 'payment'
    case OrderItemType.customerCredit: return 'customerCredit'
    case OrderItemType.giftCard: return 'giftCard'
    case OrderItemType.customerPass: return 'pass'
    case OrderItemType.customerCourse: return 'course'
    default: return 'product'
  }
})

const discountLabel = computed(() => $currency.format(props.item.discountedPrice))
const editAllow = computed(() => props.item.editAllow)
const refundAllow = computed(() => props.item.refundAllow)
const deleteAllow = computed(() => props.item.deleteAllow)
const isApplePay = computed(() => props.item.customerPayment?.typedObject?.payment_method_details?.card?.wallet?.apple_pay)
const isGooglePay = computed(() => props.item.customerPayment?.typedObject?.payment_method_details?.card?.wallet?.google_pay)
const isLink = computed(() => props.item.customerPayment?.typedObject?.payment_method_details?.card?.wallet?.link)
const isKlarna = computed(() => props.item.customerPayment?.typedObject?.payment_method_details?.klarna)
const isCashApp = computed(() => props.item.customerPayment?.typedObject?.payment_method_details?.cashapp)
const isAfterpayClearpay = computed(() => props.item.customerPayment?.typedObject?.payment_method_details?.afterpay_clearpay)
const isAmazonPay = computed(() => props.item.customerPayment?.typedObject?.payment_method_details?.amazon_pay)
const isIdeal = computed(() => props.item.customerPayment?.typedObject?.payment_method_details?.ideal)
const isKonbini = computed(() => props.item.customerPayment?.typedObject?.payment_method_details?.konbini)
const isPayByBank = computed(() => props.item.customerPayment?.typedObject?.payment_method_details?.pay_by_bank)
const isRevolutPay = computed(() => props.item.customerPayment?.typedObject?.payment_method_details?.revolut_pay)
const isWechatPay = computed(() => props.item.customerPayment?.typedObject?.payment_method_details?.wechat_pay)
const isZip = computed(() => props.item.customerPayment?.typedObject?.payment_method_details?.zip)
const isStripeOther = computed(() => props.item.customerPayment?.typedObject?.payment_method_details?.type)
const isStripe = computed(() => props.item.customerPayment?.isPaymentProcessorStripe)
const isSquare = computed(() => props.item.customerPayment?.isPaymentProcessorSquare)
const isZettle = computed(() => props.item.customerPayment?.isPaymentProcessorZettle)
const isSumUp = computed(() => props.item.customerPayment?.isPaymentProcessorSumUp)
const stripePaymentUrl = computed(() => props.item.customerPayment?.typedObject?.receipt_url)
</script>
